import { render } from "./ProductCard1.vue?vue&type=template&id=086526f9&scoped=true"
import script from "./ProductCard1.vue?vue&type=script&lang=js"
export * from "./ProductCard1.vue?vue&type=script&lang=js"

import "./ProductCard1.vue?vue&type=style&index=0&id=086526f9&scoped=true&lang=css"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086526f9"]])

export default __exports__